/** String constants for Fund Disbursement page. */
export const PAGE = {
  title: 'Fund Disbursement',
  description:
    'Manage fund disbursement. Use the filters below to refine the list.',
};

export const ACTIONS = {
  create: 'Create Fund Disbursement',
  edit: 'Update Fund Disbursement',
  delete: 'Delete Fund Disbursement',
  cancel: 'Cancel',
};

export const MESSAGES = {
  createSuccess: 'Fund disbursement created successfully.',
  createError: 'Unable to create fund disbursement. Please try again.',
  updateSuccess: 'Fund disbursement updated successfully.',
  updateError: 'Unable to update fund disbursement. Please try again.',
  updateMissingId: 'Unable to update fund disbursement: missing identifier.',
  deleteSuccess: 'Fund disbursement deleted successfully.',
  deleteError: 'Unable to delete fund disbursement. Please try again.',
};

export const CONFIRM = {
  updateTitle: 'Update fund disbursement?',
  updateMessage: 'Apply the pending changes?',
  deleteTitle: 'Delete fund disbursement?',
  deleteMessage: (name) =>
    `This will remove "${name || 'this fund disbursement'}" and any linked records. This action cannot be undone.`,
};

export const SUCCESS_DIALOG = {
  successTitle: 'Success',
  errorTitle: 'Action required',
};
